export default __webpack_public_path__ + "static/media/payment-pending-dark.f61ab371.png";